<template>
    <div class="app-container">
        <template>
            <div class="top">
                <span>
                    华思税收分类编码查询</span>
                <el-button @click="login" v-if="!to" size="small" type="primary" icon="">登录
                </el-button>
                <div v-if="to" style="font-size: 15px;color: #ccc;">
                    剩余额度:<Span style="color:red;margin-right: 10px;">{{ ed }}条</Span>
                    <el-dropdown size="small" split-button icon="el-icon-document" trigger="click" type="primary"
                        class="jc" @command="handleCommand"> {{ this.GLOBAL.userinfo.username || '账号' }}

                        <el-dropdown-menu slot="dropdown">

                            <el-dropdown-item command="gw" >打开官方网站</el-dropdown-item>

                            <el-dropdown-item command="loginout" :divided="true">退出账号</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>


            </div>
            <div class="flex">

                <el-tabs v-model="activeName">
                    <el-tab-pane label="单个查询" name="first">
                        <div style="margin-top: 5px;">
                            <el-input placeholder="请输入内容" v-model="input2" @keyup.enter.native="getbm(false)">
                                <template slot="append">
                                    <el-button :loading="loading" @click="getbm(false)" type="primary"
                                        icon="el-icon-search">搜索
                                    </el-button>
                                </template>
                            </el-input>
                        </div>
                        <div style="margin-top: 0px;">
                            <template>
                                <el-table v-loading="loading" :data="tableData" style="width: 100%" :height="height"
                                    border :cell-class-name="nameclass">
                                    <el-table-column header-align="center" align="center" prop="bm" label="分类编码">
                                        <template slot-scope="scope">
                                            <div style="display: flex;justify-content: space-around;">
                                                <div> {{ scope.row.bm }}</div>
                                                <el-button type="success" style="margin-left: 10px;" class="button-read"
                                                    @click="copybm(scope.row.bm)" :data-clipboard-text="resbm" plain
                                                    size="mini" v-if="scope.row.bm">复制
                                                </el-button>
                                            </div>


                                        </template>
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center" prop="bmmc" label="商品和服务名称">
                                        <template slot-scope="scope">

                                            <div @click="desc(scope)"> {{ scope.row.bmmc }}</div>



                                        </template>
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center" label="税率">
                                        <template slot-scope="scope">

                                            <div @click="desc(scope)"> {{ scope.row.sl }}</div>



                                        </template>
                                    </el-table-column>
                                    <el-table-column header-align="center" max-width="300px" align="center" label="描述">
                                        <template slot-scope="scope">

                                            <div> {{ scope.row.desc }}</div>



                                        </template>
                                    </el-table-column>
                                    <el-table-column width="100px" header-align="center" align="center" prop="from"
                                        label="吻合度">

                                    </el-table-column>

                                </el-table>

                            </template>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="批量查询" name="second">
                        <div>单次最多可查询 1000 个商品，超出建议分次查询。
                        </div>
                        <el-input type="textarea" rows="10" show-word-limit clearable v-model="mclist" placeholder="格式如下，一行一条，可以批量复制进文本框：
墨盒
打印机
电脑" :height="height" maxlenght="1000"></el-input>
                        <div style="display: flex;margin: 10PX 0PX;align-items: center;justify-content: space-between;">
                            <div style="float: left;">商品名称之间使用换行分隔</div>
                            <div style="float: right;">

                                <el-button :loading="loadingpl" size="small" @click="getbmbarr" type="primary">立即查询
                                </el-button>
                            </div>
                        </div>
                        <div style="margin-top: 0px;">
                            <div v-if="tableDatapl.length > 0" class="info">
                                <div>
                                    匹配完成 <Span style="color:red">{{ tableDatapl.length }}</Span> 条商品信息
                                </div>
                                <div>
                                    <el-button style="margin-left: 20px;" @click="exportExcel" size="mini">常规导出
                                    </el-button>
                                    <el-button style="margin-left: 20px;" @click="exportTxt" size="mini">按航天编码格式导出
                                    </el-button>
                                    <el-button style="margin-left: 20px;" @click="exportXml" size="mini">按百旺UKEY编码格式导出
                                    </el-button>
                                </div>
                            </div>
                            <div v-if="tableDatapl.length == 0" class="info">
                                <div>
                                    批量查询后可以选择导出到EXCEL或者直接导入开百旺航天UKEY开票系统
                                </div>

                            </div>
                            <template>
                                <el-table v-loading="loadingpl" :data="tableDatapl" style="width: 100%" border
                                    :cell-class-name="nameclass">
                                    <el-table-column header-align="center" align="center" width="80px" label="序号">
                                        <template slot-scope="scope">

                                            {{ scope.$index + 1 }}



                                        </template>
                                    </el-table-column>
                                    <el-table-column header-align="center" align="center" prop="name" label="商品名称">

                                    </el-table-column>
                                    <el-table-column header-align="center" align="center" prop="bm" label="分类编码">

                                    </el-table-column>
                                    <el-table-column header-align="center" align="center" prop="bmmc" label="大类名称">

                                    </el-table-column>
                                    <el-table-column header-align="center" align="center" prop="sl" label="税率">

                                    </el-table-column>

                                </el-table>

                            </template>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="bottom" style="">
                <span>
                    客服QQ:455586446</span>
                <span>
                    客服微信电话:13635715047</span>
                <span>
                    更多套餐请联系客服</span>

            </div>
        </template>
    </div>
</template>
<script>
var spxx = window.spxx;
import XLSX from 'xlsx'
import { getToken } from '@/utils/auth'
import Clipboard from 'clipboard';
import https from "@/https.js";
export default {
    data() {
        return {
            height: 100,
            input2: '',
            tableData: [],
            loading: false,
            loadingpl: false,
            resbm: '',
            searchtxt: '',
            activeName: 'first',
            mclist: '',
            tableDatapl: [],
            ed: '',
            to: '',

        }
    },
    created() {
        this.to = getToken();
        // this.$alert("本接口为了让大家查询编码更加方便，请大家不要随意浪费肆意点击本接口，常规编码请大家做好本地存储，请勿重复盲目查询，否则可能会影响到您使用此查询和接口赋码的功能", '提示申明')
        this.getCreate();
        this.height = "calc(100vh - 230px)";
        // _this.loading=true;
    },
    mounted() {

        // let  _this=this;
        // setTimeout(function () {

        //     _this.getbm(true);
        // }, 50)
    },
    methods: {
        handleCommand(a) {
            switch (a) {

                case "gw":
                    //  this.$refs.mychild.buy();

                    let url = 'http://www.huasivip.com';
                    //得到接口返回来的url地址，将其赋值给window.location.href，完成下载
                    window.open(url);

                    return;


                case "loginout":
                    this.$router.push({ path: this.redirect || "/login" });
                    return;
            }
        },
        login() {
            this.$router.push({
                path: "/login"
            });
        },
        copybm(bm) {

            this.resbm = bm;
            var clipboard = new Clipboard('.button-read')
            clipboard.on('success', e => {
                this.$message({
                    type: "success",
                    message: "复制成功！"
                });
                // 释放内存
                clipboard.destroy()
            })
            clipboard.on('error', e => {
                // 不支持复制
                this.$message({
                    type: "error",
                    message: "该浏览器不支持自动复制'！"
                });
                console.log('该浏览器不支持自动复制')
                // 释放内存
                clipboard.destroy()
            })

        },
        getCreate() {
            https.fetchGet("https://zhushou.huasivip.com/admin/api/public/index/bianma/geted").then(data => {
                this.ed = (data.data.ed || 0)

            })
        },
        getbm(flag) {
            if (this.input2 == "") {
                this.$message({
                    type: "error",
                    message: "名称不能为空"
                });
                return;
            }
            // if (this.input2 == this.searchtxt) {
            //     this.$message({
            //         type: "error",
            //         message: "请勿重复搜索，否则可能会对您的账号使用此功能有限制。"
            //     });
            //     return;
            // }

            this.searchtxt = (this.input2);

            let that = this;
            this.loading = true;

            this.tableData = [];
            let res = [];
            res.push({
                // u_category: "",
                // u_num: "",
                // u_type: "",
                name: this.input2

            });
            // "https://zhushou.huasivip.com/admin/api/public/index/bianma/getbmbyinfo",
            https
                .fetchPost(
                    "https://zhushou.huasivip.com/admin/api/public/index/bianmaexone/getbmznfm",
                    //"https://zhushou.huasivip.com/admin/api/public/index/bianma/getbmbyinfo",
                    // { bm: res }
                    {
                        bm: this.searchtxt
                    }

                )
                .then(data => {

                    if (data.data.describe == "请求成功") {

                        this.loading = false;


                        let bmmc = (data.data.result[0].u_short_name.toString());
                        that.tableData.push({
                            bm: data.data.result[0].u_code || "",
                            sl: parseInt(data.data.result[0].u_rate) / 100 || "",
                            bmmc: bmmc || "",
                            desc: '',
                            from: '接口'

                        });
                        var s = "([^;]*" + this.input2 + "[^;]*)";
                        var reg = new RegExp(s, "ig");
                        res = spxx.match(reg);
                        if (res != null) {
                            var len = res.length;


                            for (var i = 0; i < /*(len > 10 ? 10 : len)*/ len; i++) {
                                if (res[i]) {
                                    var cnt = res[i].split(":");
                                    var bm = cnt[0].replace(";", ""),
                                        name = cnt[1];
                                    that.tableData.push({
                                        bm: bm,
                                        sl: "内置未知",
                                        bmmc: name,
                                        desc: cnt[2],
                                        from: '内置'
                                    })
                                    // html += "<li  class='t1'><span>" + bm + "</span></li><li class='t2'><span des='" + cnt[2] + "'>" + name + "</span></li>";
                                }
                            }
                        }

                    }
                    else if (data.data.code == 0) { //B

                        var lenb = data.data.data.recommendations.length;
                        this.loading = false;
                        this.ed = data.data.ed;
                        for (var i = 0; i < lenb; i++) {
                            let bmmc = (data.data.data.recommendations[i].shortName);
                            if (bmmc == '信息技术服务') bmmc = (data.data.data.recommendations[i].parentName) || ""
                            that.tableData.push({
                                bm: data.data.data.recommendations[i].code || "",
                                sl: this.getsl(data.data.data.recommendations[i].code.toString().substring(0, 19)),
                                bmmc: bmmc || "",
                                desc: data.data.data.recommendations[i].desc || "",
                                from: data.data.data.recommendations[i].prob

                            });
                        }


                    }
                    else {
                        this.loading = false;
                        this.$alert(data.data.describe || data.data.msg || "请先登录");
                        // this.$message({
                        //     type: "error",
                        //     message: data.data.describe || data.data.msg || "请先登录"
                        // });
                    }

                })
                .catch(err => {
                    this.loading = false;
                    console.log(err);
                    this.$message(err.toString());
                });


            //$("#box").html(html);
            //console.log(new Date().getTime() - t + "ms")
        },
        getsl(bm) {
            if (!bm) return "";
            if (spxx.indexOf(bm) > -1) {
                return spxx.split(bm + ":")[1].split(":")[2] + " " + spxx.split(bm + ":")[1].split(":")[3].split(";")[0] || ""
            }
            else {
                return ""
            }
        },
        getbmbarr() {
            if (this.mclist == "") {
                this.$message({
                    type: "error",
                    message: "列表数据不能为空"
                });
                return;
            }


            let that = this;
            this.loadingpl = true;

            this.tableDatapl = [];
            let res = [];
            let bm = this.mclist.split(/[\r\n]+/)
            bm.forEach((item, index) => {
                if (!item) {
                    bm.splice(index, 1);//删除空项
                }
            })
            https
                .fetchPost(
                    "https://zhushou.huasivip.com/admin/api/public/index/bianmaexone/getbmbarr",

                    {
                        bm

                    }

                )
                .then(data => {


                    if (data.data.code == 0) {

                        var lenb = data.data.data.length;
                        this.loadingpl = false;
                        this.ed = data.data.ed;
                        for (var i = 0; i < lenb; i++) {
                            let bmmc = (data.data.data[i].recommendations[0].shortName);
                            if (bmmc == '信息技术服务') bmmc = (data.data.data[i].recommendations[0].parentName) || ""
                            that.tableDatapl.push({
                                bm: data.data.data[i].recommendations[0].code || "",
                                name: data.data.data[i].name,
                                bmmc: bmmc || "",
                                sl: this.getsl(data.data.data[i].recommendations[0].code.toString().substring(0, 19)),

                            });
                        }

                    }
                    else {
                        this.loadingpl = false;
                        this.$alert(data.data.describe || data.data.msg || "请先登录");
                        // this.$message({
                        //     type: "error",
                        //     message: data.data.describe || data.data.msg || "请先登录"
                        // });
                    }

                })
                .catch(err => {
                    this.loadingpl = false;
                    console.log(err);
                    this.$message(err.toString());
                });


        },
        exportTxt() {
            var timestamp = (new Date()).getTime();
            let txt = `{商品编码}[分隔符]","`
            txt = txt + "\n" + `// 每行格式 :`
            txt = txt + "\n" + `// 编码,名称,简码,商品税目,税率,规格型号,计量单位,单价,含税价标志,隐藏标志,中外合作油气田,税收分类编码,是否享受优惠政策,税收分类编码名称,优惠政策类型,零税率标识,编码版本号`
            this.tableDatapl.forEach((item, index) => {
                txt += "\n" + (index + 1) + `,` + item.name + `,,,0.13,,,0.0,False,0000000000,False,` + item.bm + `,否,,,,`
            })
            let str = new Blob([txt], { type: 'text/plain;charset=utf-8' });
            saveAs(str, "商品编码 -" + timestamp + ".txt");
            this.$alert("下载完成后请用记事本打开下载的文件，选择'文件'-》'另存为'-》'编码'设置为ansi格式保存。", '兼容性设置')

        },
        utf8Togbk(str1) {
            var substr = "";
            var a = "";
            var b = "";
            var c = "";
            var i = -1;
            i = str1.indexOf("%");
            if (i == -1) {
                return str1;
            }
            while (i != -1) {
                if (i < 3) {
                    substr = substr + str1.substr(0, i - 1);
                    str1 = str1.substr(i + 1, str1.length - i);
                    a = str1.substr(0, 2);
                    str1 = str1.substr(2, str1.length - 2);
                    if (parseInt("0x" + a) & 0x80 == 0) {
                        substr = substr + String.fromCharCode(parseInt("0x" + a));
                    } else if (parseInt("0x" + a) & 0xE0 == 0xC0) { //two byte
                        b = str1.substr(1, 2);
                        str1 = str1.substr(3, str1.length - 3);
                        var widechar = (parseInt("0x" + a) & 0x1F) << 6;
                        widechar = widechar | (parseInt("0x" + b) & 0x3F);
                        substr = substr + String.fromCharCode(widechar);
                    } else {
                        b = str1.substr(1, 2);
                        str1 = str1.substr(3, str1.length - 3);
                        c = str1.substr(1, 2);
                        str1 = str1.substr(3, str1.length - 3);
                        var widechar = (parseInt("0x" + a) & 0x0F) << 12;
                        widechar = widechar | ((parseInt("0x" + b) & 0x3F) << 6);
                        widechar = widechar | (parseInt("0x" + c) & 0x3F);
                        substr = substr + String.fromCharCode(widechar);
                    }
                } else {
                    substr = substr + str1.substring(0, i);
                    str1 = str1.substring(i);
                }
                i = str1.indexOf("%");
            }

            return substr + str1;
        },
        exportXml() {
            var timestamp = (new Date()).getTime();
            let txt = `<?xml version="1.0" encoding="ANSI"?>`
            txt = txt + "\n" + `<Data TYPE="SPBIANMA">\n<SPXX>`

            this.tableDatapl.forEach((item, index) => {
                txt += "\n" + `<Row DJ="" JM="" GGXH="" HSBZ="1" SLLX="0" SL="" PID="100" OLD_PID="100" BM="10000001" SPSM="" SPFLBM="` + item.bm + `" JLDW="" MC="` + (item.name) + `" SYYHBZ="0" YHZC=""/>`
            })
            txt += "\n" + "</SPXX>"
            txt += "\n" + "</Data>"

            let str = new Blob([(txt)], { type: 'text/plain' });
            saveAs(str, "商品编码 -" + timestamp + ".xml");
            this.$alert("下载完成后请用记事本打开下载的文件，选择'文件'-》'另存为'-》'编码'设置为ansi格式保存。", '兼容性设置')



        },
        exportExcel() {





            var wb = XLSX.utils.book_new();
            let obj = JSON.parse(JSON.stringify(this.tableDatapl));


            //json转sheet
            var ws = XLSX.utils.json_to_sheet(obj, { header: [], skipHeader: false });
            //设置列宽

            var timestamp = (new Date()).getTime();
            //sheet写入book
            XLSX.utils.book_append_sheet(wb, ws, "file");
            //输出
            XLSX.writeFile(wb, "商品编码 -" + timestamp + ".xlsx");
        },
        nameclass({ row, column, rowIndex, columnIndex }) {

            if (columnIndex == 1) {
                return 'nameclass'
            }
            else {
                return ''
            }
        },
        desc(scope) {
            if (scope.row.desc) {
                this.$alert(scope.row.desc, scope.row.name)
            }


        }

    },
}

</script>
<style scoped>
.flex {
    padding-top: 70px;
    margin: auto;
    width: 1200px;
    max-width: 95%;
}

.app-container {}

.top {
    height: 60px;
    background: #10162a;
    width: 100%;
    color: white;
    position: fixed;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap:wrap;

}

.bottom {
    height: 50px;
    background: #10162a;
    width: 100%;
    bottom: 0px;
    color: white;
    position: fixed;
    font-size:17px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    flex-wrap:wrap;

}
</style>
<style>
.el-input-group>.el-input__inner {
    text-align: center;
    font-size: 18px !important;
}

.el-input-group__append {
    background-color: #f56c6c !important;
    color: #fff !important;
}

.nameclass {
    text-decoration: underline;
    color: #f56c6c;
    cursor: pointer
}

.info {
    background: #ede6e6;
    padding: 10px 5px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

body {
    margin: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/bianma.vue


// WEBPACK FOOTER //
// src/components/bianma.vue